<template>
  <div class="interiorzone">
    <h2 class="subheading">合作机构列表</h2>
    <div class="content-organ-search">
      <div class="searchwhere"><input type="text" name="" placeholder="输入要检索的机构名称" v-model="companyName"/><button @click="readlist()">确定</button></div>
    </div>
    <div class="contentbox">
      <div class="content-order-listbox">
        <ul class="content-organ-list">
          <li class="hd">
            <span>序号</span>
            <span>公司名称</span>
            <span>统一社会信用代码</span>
            <span>详细地址</span>
            <span>法人姓名</span>
            <span>法人身份证</span>
            <span>代理人姓名</span>
            <span>代理人身份证</span>
            <span>操作</span>
          </li>
          <li  v-for="(item,index) in companylist" v-bind:key="index">
            <span>{{index + 1}}</span>
            <span>{{item.companyName}}</span>
            <span>{{item.organizationCode}}</span>
            <span>{{item.companyAddr}}</span>
            <span>{{item.legalName}}</span>
            <span>{{item.legalCardCode}}</span>
            <span>{{item.agentName}}</span>
            <span>{{item.agentCardCode}}</span>
            <span class="infoperation"><div class="ysbox"><i @click="lookdetails(index)">查看详情</i></div></span>
          </li>
        </ul>
        <ul class="listpage" v-if="ifpageshow">
          <li @click="loadata(1)">首页</li> <!--这里是1-->
          <li v-for="(item,index) in pagenum" v-bind:key="index" :class="currentPage==item?'active':''"  @click="nextpage(item)">{{item}}</li>
          <li @click="loadata(total)">尾页</li><!--这里是pagenum-->
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pagenum:0,
      currentPage:1,
      pageSize:10,
      companyName:'',
      companylist:[],
      ifpageshow:false
    }
  },
  mounted:function() {
    this.readlist();
  },
  methods: {
    readlist(){
      this.ajax.post('/auth/channelList',{bizContent:{currentPage:this.currentPage,pageSize:this.pageSize,companyName:this.companyName}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.pagenum=result.data.data.pages
            this.pagenum>1?this.ifpageshow=true:this.ifpageshow=false
            this.companylist=result.data.data.listResponse
          }
        }
      )
    },
    nextpage(item){
      this.currentPage=item
      this. readlist()
    },
    lookdetails(val){
      this.$router.push({name:'OrganDetails', params: { companyinfo:this.companylist[val]}})
    }
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/page/partner/organlist.vue